(ns frontend.view.kpi-reporting.kpi-offer.view
  (:require [frontend.state.current-session :as session]
            [common.features.plan :as plan]
            [frontend.routing :as routing]
            [frontend.logging :as logging]
            [frontend.bootstrap.components :as rbs]
            [frontend.actions.kpi :as kpi-actions]
            [frontend.view.modals.notification.view :as notification]
            [frontend.view.kpi-reporting.kpi-offer.events :as events]
            [frontend.view.modals.video.view :as video-modal]
            [frontend.view.modals.events :as modals]
            [frontend.utils :as fu]
            [ui.components.button.view :as button]))

(defn view []
  [:div.kpi-offer-page
   [:div.kpi-offer
    [:div
     {:class "container"}
     [:h2 "Take your portfolio reporting routines to the next level"]
     [:div
      {:class "grid grid-cols-2 gap-4"}
      [:div {:class "order-sm-2"}
       [:div
        [:h3 "How can Zapflow help?"]
        [:p "Our support team is happy to set up your reporting flow in a way that allows you to enjoy structured reporting data pour in on time. In brief, you define what data (numeric and/or qualitative) your want companies to submit every month or quarter. As you don’t need excels or pdfs anymore, you’ll get the answers you need quicker and without all the hassle."]
        [:ul
         [:li [:i.fal.fa-check] [:span "Eliminate the Excel back and forth"]]
         [:li [:i.fal.fa-check] [:span "Eliminate human errors"]]
         [:li [:i.fal.fa-check] [:span "Eliminate clutter"]]
         [:li [:i.fal.fa-check] [:span "Spend less time with nonsense and focus on creating value"]]
         ]

        [:p "To take your reporting to the next level, reach out to your contact person."]]]

      [:div {:class "order-sm-1"}
       [:div.video-section
        [:h3 "Watch the 30sec video below!"]
        [:div.video-wrapper
         [:img.video-still
          {:src "/img/kpi-still.jpg"}]
         [:i.fas.fa-play-circle
          {:on-click (fn [_]
                       (events/update-preferences {:seen-kpi-offer true
                                                   :seen-kpi-video true})
                       (modals/open-modal!
                         video-modal/modal-key
                         {:src "https://player.vimeo.com/video/341577794"}))}]]]
       [:div.text-center.mb-4.d-md-none
        [button/primary-solid
         {:type  "button"}
         "Turn feature on for a free trial"]
        [:span.learn-more.d-none "Learn more below"]]
       ]
      ]]
    ]])
